import React from "react";
import { Loader } from "../_components";

export default function RedirectionOdoo() {
  return (
    <Loader message={"Redirecting to Odoo... Please wait."} isShown={true} />
  );
}
